import React from 'react';
import Valedictoryceremony9to122024 from 'views/Valedictoryceremony9to122024'
const SchoolProgrampage = () => {
  return <Valedictoryceremony9to122024 />;
};
export default SchoolProgrampage;